<template>
    <div class="avatar" :class="classes" v-tooltip="tooltipMessage">
        <img v-if="hasAvatar" :src="user.private_avatar_url" :alt="user.display_name" class="lc-avatar-image avatar__image">
        <div v-else class="lc-avatar-initials avatar__initials">
            <span>{{ user.initials }}</span>
        </div>
        <span v-if="isOnline" class="avatar__status"></span>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'Avatar',

    props: {
        user: {
            type: Object,
            required: true
        },
        showTooltip: {
            type: Boolean,
            default: true
        }
    },

    computed: {
        ...mapState('users', ['onlineUsers']),

        classes () {
            return {
                [`avatar--${this.user.role}`]: true,
                'avatar--deleted': this.user.is_deleted
            }
        },

        hasAvatar () {
            return this.user.avatar_status === 'complete'
        },

        isOnline () {
            return this.onlineUsers.filter(user => user.id === this.user.id).length > 0
        },

        tooltipMessage () {
            if (!this.showTooltip) {
                return ''
            }

            return this.user.display_name + ' - <span>' + this.user.role_name + '</span>'
        }
    }
}
</script>
